import { Button, Modal, rem, TextInput } from "@mantine/core";
import React, { useState } from "react";
import { notifications } from "@mantine/notifications";
import { IconCheck } from "@tabler/icons-react";
import { AdvancedSettings, PlayerColor, Position } from "../models";
import AdvancedSettingsComponent from "./AdvancedSettings";

interface Props {
    opened: boolean;
    close: () => void;
    position: Position;
    onEditPosition: (name: string, advancedSettings: AdvancedSettings) => void;
    playerColor: PlayerColor;
}

const EditPositionModal: React.FC<Props> = ({ opened, close, position, onEditPosition, playerColor }) => {
    const [selectedName, setSelectedName] = useState(position.name);
    const [advancedSettings, setAdvancedSettings] = useState<AdvancedSettings>({
        engineSource: position.engineSource || "lichess",
        lichessPlayer: position.lichessPlayer,
        timeControls: position.timeControls || ["bullet", "blitz", "rapid", "classical"],
        sinceYear: position.sinceYear,
        sinceMonth: position.sinceMonth,
    });

    return (
        <Modal
            opened={opened}
            onClose={close}
            title={`Edit ${playerColor === "w" ? "white" : "black"} opening`}
            centered
            padding={20}
        >
            <div className="">
                <TextInput
                    className="mb-4"
                    label="Name"
                    value={selectedName}
                    onChange={(e) => setSelectedName(e.target.value)}
                />
                <AdvancedSettingsComponent
                    advancedSettings={advancedSettings}
                    setAdvancedSettings={setAdvancedSettings}
                />
                <Button
                    className="mt-6"
                    color="green"
                    h="3rem"
                    onClick={() => {
                        onEditPosition(selectedName, advancedSettings);
                        notifications.show({
                            title: "Position updated",
                            message: "",
                            icon: <IconCheck style={{ width: rem(18), height: rem(18) }} />,
                            color: "green",
                        });
                        close();
                    }}
                    fullWidth
                >
                    <span className="text-lg">Edit</span>
                </Button>
            </div>
        </Modal>
    );
};

export default EditPositionModal;
